export default "__VITE_ASSET__65b17a64__"